import { SettingsQuery } from '@state/settings/settings.query';
import {ClinicService} from '@state/clinic/clinic.service';
import {SettingsService} from '@state/settings/settings.service';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {switchMap, tap} from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class InitFlowwwService {
    private initialized = false;

    constructor(
        private clinicService: ClinicService,
        private settingsQuery: SettingsQuery,
        private settingsService: SettingsService
    ) {}

    init(): Observable<void> {
        if (this.initialized || this.settingsQuery.settingsLoaded) {
            return of(void 0);
        }

        return this.settingsService.initFlowwwMe().pipe(
            switchMap(() => this.clinicService.initClinic()),
            tap(() => this.initialized = true)
        );
    }
}
